<!-- <spaceship *ngIf="isSpaceshipEasterEggActive"></spaceship> -->
<router-outlet></router-outlet>
